var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMetamask(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 1L7.5 5L8.42979 2.64267L12.5 1Z",
    fill: "#E17726",
    stroke: "#E17726",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 1L6.5 5L5.60679 2.62748L1.5 1Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9521 10L9.5 12.1646L12.6093 13L13.5 10.0473L10.9521 10Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 10.0473L1.38768 13L4.5 12.1646L3.04938 10L0.5 10.0473Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.34209 6.69267L3.5 7.87317L6.5 8L6.40001 5L4.34209 6.69267Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.65788 6.70739L7.56843 5L7.5 8L10.5 7.8746L9.65788 6.70739Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 12L6.5 11.1629L4.77827 10L4.5 12Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 11.1629L9.5 12L9.22673 10L7.5 11.1629Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 12.047L7.5 11L7.66277 12.4044L7.64532 13L9.5 12.047Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 12.047L6.35511 13L6.3435 12.4044L6.5 11L4.5 12.047Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 9L4.5 8.52544L5.20628 8L5.5 9Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 9L8.79269 8L9.5 8.52544L8.5 9Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M4.18552 12L4.5 10L2.5 10.0437L4.18552 12Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 10L9.80819 12L11.5 10.0437L9.5 10Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7L7.5 7.16301L7.77894 9L8.22106 7.89027L9.28949 8.47334L10.5 7Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M4.71579 8.47334L5.77894 7.89027L6.22107 9L6.5 7.16301L3.5 7L4.71579 8.47334Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 8L4.5 10L4.4665 9.00643L3.5 8Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M9.53765 9.00643L9.5 10L10.5 8L9.53765 9.00643Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M6.51924 8L6.44922 9.37562L6.53773 11L6.55755 8.85917L6.51924 8Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M7.48667 8L7.44922 8.85449L7.46795 11L7.55755 9.37562L7.48667 8Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M7.87853 9.36209L7.5 10.8534L7.7712 11L9.44916 10L9.5 9L7.87853 9.36209Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9L4.54536 10L6.22804 11L6.5 10.8534L6.1204 9.36209L4.5 9Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00518 12.6104L8.01921 12.2289L7.8974 12.1406H6.10733L5.99017 12.2289L5.99955 12.6104L4.5 12L5.02483 12.3695L6.08857 13H7.91143L8.97985 12.3695L9.5 12L8.00518 12.6104Z",
    fill: "#C0AC9D",
    stroke: "#C0AC9D",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M7.37065 11.1318L7.14894 11H5.84641L5.62472 11.1318L5.5 12L5.61548 11.9147H7.3799L7.5 12L7.37065 11.1318Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0384 5.00165L13.5 2.92821L12.805 1L7.5 4.63106L9.5416 6.22369L12.4249 7L13.0602 6.31386L12.7833 6.12853L13.2231 5.75794L12.8864 5.51753L13.3263 5.207L13.0384 5.00165Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 2.92821L0.966969 5.00165L0.668328 5.207L1.11358 5.51753L0.776924 5.75794L1.21674 6.12853L0.939818 6.31386L1.57512 7L4.4584 6.22369L6.5 4.63106L1.19502 1L0.5 2.92821Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5965 6.87445L9.90102 6L10.7132 7.36532L9.5 10L11.1041 9.97745H13.5L12.5965 6.87445Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M4.09847 6L1.39962 6.87445L0.5 9.97745H2.89391L4.5 10L3.28527 7.36532L4.09847 6Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M7.67785 7.88672L7.82654 5.03165L8.5 3H5.5L6.17346 5.03165L6.32215 7.88672L6.379 8.78318L6.38338 11H7.61662L7.621 8.78318L7.67785 7.88672Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.bde28c58fffd5eec9a35127ee3980a44.svg";
export { ForwardRef as ReactComponent };